import styled from 'styled-components'

export const LinkButton = styled.button`
  display: inline;
  appearance: none;
  border: none;
  padding: 0;
  background: none;

  font-family: "SF Pro Display";
  font-size: 18px;
  color: #d57b20;
  text-decoration: underline;

  :focus, :hover, :active {
    color: #AD641A;
  }
`



// WEBPACK FOOTER //
// ./src/atoms/LinkButton.tsx